/**
 * API helper for provider-routed speech-to-text plus the legacy local TTS
 * endpoint. Assistant reply playback normally uses the browser Web Speech API.
 */
import axios from "axios";
import { API } from "./client";

function extensionForMimeType(mimeType) {
  if (!mimeType) return "webm";
  if (mimeType.includes("mp4") || mimeType.includes("m4a")) return "mp4";
  if (mimeType.includes("wav")) return "wav";
  if (mimeType.includes("mpeg") || mimeType.includes("mp3")) return "mp3";
  if (mimeType.includes("ogg")) return "ogg";
  return "webm";
}

/** Send a recorded audio blob for transcription (Gemini). Returns { text }. */
export const transcribeVoice = (blob) => {
  const formData = new FormData();
  // Filename extension must match the blob's actual codec/container (varies by browser —
  // e.g. Safari records audio/mp4, not webm).
  formData.append("audio", blob, `recording.${extensionForMimeType(blob.type)}`);
  return axios.post(`${API}/assistant/voice/transcribe`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 30000,
  });
};

/** Get spoken audio (OpenAI TTS) for a reply. Returns an axios response with a Blob body. */
export const speakText = (text) =>
  axios.post(`${API}/assistant/voice/speak`, { text }, { responseType: "blob", timeout: 30000 });
